<template>
  <div class="f360-aviso-financeiro vc-background--warning" v-if="showBanner">
    <div class="content-left">
      <p>
        <b>ATENÇÃO</b> A partir de abril de 2025, a F360 passará a emitir seus
        boletos pelo <b>Banco Itaú</b>.
      </p>
    </div>
    <div class="content-right">
      <el-button class="banner-button" @click="handleLink">
        <span class="banner-button__label">
          Financeiro
          <MaterialIcon class="banner-button__icon" icon="arrow_outward" />
        </span>
      </el-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import useBannerAvisoBoleto from "@/core/composables/BannersHandlers/BannerAvisoBoleto/useBannerAvisoBoleto";
import { ElButton } from "element-plus/es/components/button/index";
import { onMounted, ref } from "vue";

const showBanner = ref(false);

const handleLink = () => {
  window.open("/Financeiro", "_blank");
};

onMounted(() => {
  showBanner.value = useBannerAvisoBoleto().showBannerBoleto();
});
</script>

<style lang="scss" scoped>
@use "@/ui/styles/theme/f360-theme" as *;
@use "@/ui/styles/variables" as *;

.f360-aviso-financeiro {
  font-family: $fontFamily;
  width: auto;
  height: 1.875rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.7rem;
  color: #2e2e2e;
  font-weight: 400;
  font-size: 14px;
  line-height: 32px;
  margin: 7px 0 0px 0;
  border-radius: 5px;

  .content-left {
    display: flex;
    align-items: center;
  }

  .content-right {
    display: flex;
    align-items: center;

    p {
      margin-right: 10px;
    }

    .banner-button {
      height: 32px;
      width: fit-content;
      padding: 0 5px;
      border-radius: 5px;
      border: 1px solid #e7e7e7;
      background-color: #fff;
      color: #d19700;
      cursor: pointer;

      &__label {
        display: flex;
        align-items: center;
        gap: 3px;

        font-family: $fontFamily;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;

        &--small {
          font-size: 10px;
          line-height: 10px;
        }
      }

      &__icon {
        font-size: 18px;
      }

      @media (min-width: 768px) and (max-width: 1200px) {
        .display-btn-text {
          display: none;
        }
      }
    }

    .banner-button:hover {
      background-color: #f5f5f5;
    }
  }

  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    height: auto;

    .content-left {
      display: flex;
      flex-direction: column;

      p {
        text-align: center;
      }
    }
  }
}
</style>
